/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useInvoices = (page, queryParams) => {
  return useQuery({
    queryKey: queryKeys.invoices.list(page),
    queryFn: () => fetcher({ method: "GET", url: "/public/invoice", params: { page, on_page: 10 } }),
    placeholderData: keepPreviousData,
    ...queryParams,
  });
};
